import { APPLICATION_GROUP_BY, Route } from '@/core/entities/types/routes';
import { createRouteLoaderPageDetails } from '@/core/utils/routes.utils';
import Main from '@/core/views/main/main';
import { COMPANY_CONFIG } from '@/modules/company/entities/enums/company';
import { Details } from '@/modules/copay/pages/details/details';
import { List } from '@/modules/copay/pages/list/list';
import { USER_TYPE } from '@/services/users/endpoints/users';
import ICONS from '@/shared/entities/constants/icons';

export enum COPAY_AUDIT {
  LIST = 'copay-list',
  DETAIL = 'copay-detail',
}

const pageName = 'Isenção de coparticipação';

const Routes: Route[] = [
  {
    path: '/copaies',
    Component: Main,
    id: COPAY_AUDIT.LIST,
    meta: {
      groupedBy: APPLICATION_GROUP_BY.BROKER,
      showApplicationMenu: true,
      customImageUrl: ICONS.MONEY_SIGN,
      nameMenu: pageName,
      permission: {
        type: USER_TYPE.BROKER,
        companyConfigs: [COMPANY_CONFIG.COPAY_EXEMPTION],
      },
    },
    loader() {
      return createRouteLoaderPageDetails({
        groupedBy: APPLICATION_GROUP_BY.BROKER,
        title: pageName,
      });
    },
    children: [
      {
        index: true,
        Component: List,
      },
      {
        path: ':usageStatementProcessId/details',
        id: COPAY_AUDIT.DETAIL,
        Component: Details,
        loader() {
          return createRouteLoaderPageDetails({
            groupedBy: APPLICATION_GROUP_BY.BROKER,
            customImageUrl: ICONS.MONEY_SIGN,
            name: pageName,
            hasGoBackAction: true,
            title: `${pageName} | Detalhes`,
          });
        },
      },
    ],
  },
];

export default Routes;
